interface ENetsErrorData {
  netsStageRespCode?: string;
  netsTxnMsg?: string;
  isRetry?: boolean;
  merchantTxnRef?: string;
  netsTxnRef?: string;
}

const getCombinedCodeAndMessage = (code?: string, message?: string): string => {
  if (code && message) {
    return `${code} ${message}`;
  }
  if (code) {
    return code;
  }
  if (message) {
    return message;
  }
  return '';
};

export const getENetsErrorMessages = ({
  netsStageRespCode = undefined,
  netsTxnMsg = undefined,
  isRetry = undefined,
  merchantTxnRef = undefined,
  netsTxnRef = undefined,
}: ENetsErrorData): string[] => {
  let errorMessagesFromEnets: string[] = [getCombinedCodeAndMessage(netsStageRespCode, netsTxnMsg)];

  // backend reject transaction, didn't go through enets
  if (!merchantTxnRef && !netsTxnRef) {
    if (isRetry) {
      errorMessagesFromEnets = [...errorMessagesFromEnets, 'Please retry.'];
    } else {
      errorMessagesFromEnets = [...errorMessagesFromEnets, 'Please do not retry and contact SEAB.'];
    }
  }

  if (merchantTxnRef) {
    errorMessagesFromEnets = [...errorMessagesFromEnets, `CP Reference No.: ${merchantTxnRef}`];
  }
  if (netsTxnRef) {
    errorMessagesFromEnets = [...errorMessagesFromEnets, `Transaction No.: ${netsTxnRef}`];
  }

  return errorMessagesFromEnets;
};
